import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IArtikeltexteDID } from 'app/shared/model/artikeltexte-did.model';
import { getEntities } from './artikeltexte-did.reducer';

export const ArtikeltexteDID = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const artikeltexteDIDList = useAppSelector(state => state.artikeltexteDID.entities);
  const loading = useAppSelector(state => state.artikeltexteDID.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  return (
    <div>
      <h2 id="artikeltexte-did-heading" data-cy="ArtikeltexteDIDHeading">
        <Translate contentKey="integrawebApp.artikeltexteDID.home.title">Artikeltexte DIDS</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="integrawebApp.artikeltexteDID.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/artikeltexte-did/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="integrawebApp.artikeltexteDID.home.createLabel">Create new Artikeltexte DID</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {artikeltexteDIDList && artikeltexteDIDList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="integrawebApp.artikeltexteDID.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.artikeltexteDID.createdDate">Created Date</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.artikeltexteDID.createdBy">Created By</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.artikeltexteDID.lastModifiedDate">Last Modified Date</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.artikeltexteDID.lastModifiedBy">Last Modified By</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {artikeltexteDIDList.map((artikeltexteDID, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/artikeltexte-did/${artikeltexteDID.id}`} color="link" size="sm">
                      {artikeltexteDID.id}
                    </Button>
                  </td>
                  <td>
                    {artikeltexteDID.createdDate ? (
                      <TextFormat type="date" value={artikeltexteDID.createdDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{artikeltexteDID.createdBy}</td>
                  <td>
                    {artikeltexteDID.lastModifiedDate ? (
                      <TextFormat type="date" value={artikeltexteDID.lastModifiedDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{artikeltexteDID.lastModifiedBy}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/artikeltexte-did/${artikeltexteDID.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/artikeltexte-did/${artikeltexteDID.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/artikeltexte-did/${artikeltexteDID.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="integrawebApp.artikeltexteDID.home.notFound">No Artikeltexte DIDS found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ArtikeltexteDID;
